<template>
  <div class="slider slider1 position-absolute">
  
    <div class="slider position-absolute">
      <div class="silder-bg-img block">
        <img
          src="../../assets/img/home/bg.jpg"
          alt=""
          srcset=""
          :style="scaleStyle"
        />
      </div>
      <div class="embed-responsive-16by9">
        <video
          loop
          muted
          autoplay
          class="videobox position-absolute"
          :style="scaleStyle"
        >
          <!-- https://resource-mp4.ujoygames.com/panilla/bg_l.mp4 -->
          <source
            src="https://resource-mp4.ujoygames.com/panilla/bg_l_20221009.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
    <!-- 内容区域 -->

    <div class="position-relative cont">
      <div
        class="ani"
        swiper-animate-effect="fadeInUp"
        swiper-animate-duration="0.3s"
        swiper-animate-delay="0.1s"
      >
        <!-- 播放按钮 -->
        <div class="player position-absolute cursor" @click="showVideo"></div>
      </div>
    </div>
    <!-- 箭头滚动提示滑动到下一页 -->
    <div class="arrows position-absolute">
      <!-- <img src="../../assets/img/home/scroll.png" alt="" srcset="" /> -->
    </div>
    <!-- 视频弹出框 -->
    <div class="model position-absolute" v-if="videoFlag">
      <div class="f-v">
        <div :style="common.handleScale()">
          <div class="embed-video">
            <video loop  autoplay preload="false" class="grtyoutube-iframe">
              <source
                src="https://resource-mp4.ujoygames.com/phantasia/pv.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div
            class="btn position-absolute hiddenVideo cursor"
            @click="handleHideVideo"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // props:['finishVal'],
  created() {
    // this.handleStyle();
  },
  mounted() {
    this.handleVideoSizeStyle();
    window.addEventListener("resize", () => {
      this.handleVideoSizeStyle();
    });
  },
  data() {
    return {
      videoFlag: false,
      // wFlag: false,
      scaleStyle: {},
    };
  },

  methods: {
    // 显示video
    showVideo() {
      this.videoFlag = true;
      this.$emit("handleChangeModel", true);
    },
    //
    handleHideVideo() {
      this.videoFlag = false;
      this.$emit("handleChangeModel", false);
    },
    handleVideoSizeStyle() {
      this.scaleStyle = this.common.handleVideoSize();

    },
  },
};
</script>
<style lang="scss" scoped>
.slider1 {
  z-index: 1;
  overflow: hidden;
  width: 100%;
  height: 100%;
  .slider-none {
    z-index: 0;
    display: none;
  }
  .silder-bg {
    z-index: 999;
  }
  .cont {
    z-index: 99;
    .player {
      background: url("../../assets/img/home/player.png") no-repeat top;
      background-size: 100% 100%;
      width: 96px;
      height: 96px;
      top: 320px;
      left: 50%;
      margin-left: -48px;
      transform: translate(-50%, 0);
      animation: player 15s infinite linear;
    }
  }

  // 视频
  .f-v {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .embed-video {
      max-width: 100%;
      width: 1102px;
      border: 1px solid #e9c57e;
      .grtyoutube-iframe {
        width: 100%;
        height: 619px;
      }
    }
    .hiddenVideo {
      background: url("../../assets/img/home/close.png") no-repeat center;
      background-size: 100% 100%;
      margin: auto;
      width: 48px;
      height: 48px;
      top: 0;
      right: -60px;
    }
  }
  // 箭头滚动
  .arrows {
    background: url("../../assets/img/home/scroll.png") no-repeat center;
    background-size: 100% 100%;
    width: 24px;
    height: 60px;
    bottom: 60px;
    left: 50%;
    animation: scrollAni 1s infinite;
    transition: all 15s;
    z-index: 999;
  }
}
@keyframes player {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

@keyframes scrollAni {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
    opacity: 0.3;
  }
  100% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
    opacity: 0;
  }
}
.silder-bg-img {
  z-index: 1;

  img {
    position: absolute;
    top: 0;
    left: 50%;
    object-fit: fill;

    // transform: translateX(-50%) translateY(-50%);
    // position: absolute;
    // top: 50%;
    // left: 100%;
    // min-width: 100%;
    // min-height: 100%;
    // max-width: none;
    // width: auto;
    // height: auto;
  }
}
.videobox {
  -o-object-fit: fill;
  object-fit: fill;
  top: 0;
  left: 50%;
  overflow: hidden;
  position: absolute;
  z-index: 2;
  background-size: 100%;
  //  transform: translateX(-50%) translateY(-50%);
  //   position: absolute;
  //   top: 50%;
  //   left: 100%;
  //   min-width: 100%;
  //   min-height: 100%;
  //   max-width: none;
  //   width: auto;
  //   height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/home.vue